import { render, staticRenderFns } from "./EmbedBuilder.vue?vue&type=template&id=5de786c2"
import script from "./EmbedBuilder.vue?vue&type=script&lang=js"
export * from "./EmbedBuilder.vue?vue&type=script&lang=js"
import style0 from "./EmbedBuilder.vue?vue&type=style&index=0&id=5de786c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports